import { styled } from "styled-components";
import theme from "../../styles/theme";
import { ResponsiveBar } from "@nivo/bar";
import { useEffect, useState } from "react";
import { useGetThisNext } from "../../interfaces/dashboard";

const MainWrap = styled.div`
    height: 100%;
    max-height: 100%;
    width: 100%;
    background: ${(props)=>props.color ? props.color:theme.color.white[100]};
    border-radius: 12px;
    padding: 0rem 1rem;
    .title {
        font-size: 1.25rem;
    }
    display:flex;
    align-items:center;
    font-weight: ${(props)=>props.color ? 600:400};
`;
const SampleData = [
    { title:'다음주', '설치/촬영':5/15,'코딩':5/15,'완료/납품':5/15,labelData:{'설치/촬영':5,'코딩':5,'완료/납품':5}},
    { title:'이번주', '설치/촬영':10/30,'코딩':10/30,'완료/납품':10/30,labelData:{'설치/촬영':10,'코딩':10,'완료/납품':10}},
]
const NowNext = (props) => {

    const [list, setList] = useState([]);
    const {data} = useGetThisNext();

    useEffect(()=>{
        if(data){
            const temp = data.map((item,index)=>{
                const i = item.I !== 0 ? item.I : 1;
                const s = item.S !== 0 ? item.S : 1;
                const e = item.E !== 0 ? item.E : 1;
                const sum = i+s+e;
                return (
                    {
                        title: item.title,
                        '설치/촬영':i/sum*100,
                        '코딩':s/sum*100,
                        '완료/납품':e/sum*100,
                        labelData:{
                            '설치/촬영':item.I,
                            '코딩':item.S,
                            '완료/납품':item.E,
                        }
                    }
                )
            })

            setList(temp);
        }else{
            setList(SampleData);
        }
    },[data])

    return (
        <MainWrap color={props.color}>
            {/* <span className="title">이번주/다음주</span> */}
            <div style={{width:'calc(100% - 0.5rem)',maxWidth:'calc(100% - 0.5rem)',height:'calc(100% - 1rem)'}}>
                <ResponsiveBar
                    theme={{fontSize:props.color?'1rem':'0.8rem'}}
                    data={list}
                    keys={[
                        '설치/촬영',
                        '코딩',
                        '완료/납품',
                    ]}
                    indexBy="title"
                    margin={{ top: 0, right: 0, bottom: 0, left: props.color?56:46 }}
                    padding={0.2}
                    innerPadding={props.color?0:3}
                    layout="horizontal"
                    valueScale={{ type: 'linear' }}
                    indexScale={{ type: 'band', round: true }}
                    // colorBy="indexValue"
                    // colors={[theme.color.setting, theme.color.coding, theme.color.complete]}
                    colors={[theme.color.setting2, theme.color.coding2, theme.color.complete2]}
                    borderColor={{ theme: 'background' }}
                    axisTop={null}
                    axisRight={null}
                    axisBottom={null}
                    axisLeft={{
                        tickSize: props.color?0:6,
                        tickPadding: props.color?6:2,
                        tickRotation: 0,
                        legendOffset: -40
                    }}
                    
                    minValue={0}
                    maxValue={'auto'}
                    enableGridY={false}
                    labelSkipWidth={20}
                    label={d=>{return d.value>20?`${d.id} : ${d.data.labelData[d.id]}`:d.data.labelData[d.id]}}
                    labelSkipHeight={12}
                    labelTextColor={props.color?'#efefef':'#333333'}
                    tooltip={()=>{return false}}
                />
            </div>
        </MainWrap>
    )
}

export default NowNext;
